import React from 'react';

function UsageGallery({ onImageClick, lang }) {
  // All images from usage-gallery folder
  const galleryImages = [
    {
      src: '/images/products/usage-gallery/01_1_Corona-Camera_003.jpg',
      alt: lang === 'it' ? 'Termoventilatore GPO nell\'ambiente' : 'Обогреватель GPO в интерьере',
      title: lang === 'it' ? 'Termoventilatore in soggiorno moderno' : 'Обогреватель в современной гостиной'
    },
    {
      src: '/images/products/usage-gallery/01_1_Corona-Camera_005.jpg',
      alt: lang === 'it' ? 'Termoventilatore a pannelli GPO' : 'Панельный обогреватель GPO',
      title: lang === 'it' ? 'Design elegante nell\'ambiente' : 'Стильный дизайн в интерьере'
    },
    {
      src: '/images/products/usage-gallery/01_1_CoronaFifth-Camera_003.jpg',
      alt: lang === 'it' ? 'Termoventilatore GPO a parete' : 'Обогреватель GPO на стене',
      title: lang === 'it' ? 'Installazione a parete del termoventilatore' : 'Настенная установка обогревателя'
    },
    {
      src: '/images/products/usage-gallery/01_1_CoronaForth-Camera_002.jpg',
      alt: lang === 'it' ? 'Termoventilatore a infrarossi GPO' : 'Инфракрасный обогреватель GPO',
      title: lang === 'it' ? 'Riscaldamento ambiente' : 'Обогрев помещения'
    },
    {
      src: '/images/products/usage-gallery/01_1_CoronaForth-Camera_005.jpg',
      alt: lang === 'it' ? 'Termoventilatore in stanza' : 'Обогреватель в комнате',
      title: lang === 'it' ? 'Riscaldamento confortevole' : 'Комфортное отопление'
    },
    {
      src: '/images/products/usage-gallery/01_1_CoronaSecond-Camera_002.jpg',
      alt: lang === 'it' ? 'Termoventilatore in vetro GPO' : 'Стеклянный обогреватель GPO',
      title: lang === 'it' ? 'Pannello in vetro premium' : 'Премиум стеклянная панель'
    },
    {
      src: '/images/products/usage-gallery/01_1_CoronaThird-Camera_004.jpg',
      alt: lang === 'it' ? 'Termoventilatore GPO in uso' : 'GPO обогреватель в использовании',
      title: lang === 'it' ? 'Riscaldamento efficiente' : 'Эффективное отопление'
    },
    {
      src: '/images/products/usage-gallery/01_2_CoronaFifth-Camera_001.jpg',
      alt: lang === 'it' ? 'Termoventilatore GPO - vista laterale' : 'Обогреватель GPO - вид сбоку',
      title: lang === 'it' ? 'Design ultra-sottile' : 'Ультратонкий дизайн'
    },
    {
      src: '/images/products/usage-gallery/01_2_CoronaSecond-Camera_001.jpg',
      alt: lang === 'it' ? 'Termoventilatore a pannelli nell\'ambiente' : 'Панельный обогреватель в интерьере',
      title: lang === 'it' ? 'Armonia con l\'ambiente' : 'Гармония с интерьером'
    },
    {
      src: '/images/products/usage-gallery/01_2_CoronaThird-Camera_001.jpg',
      alt: lang === 'it' ? 'Riscaldamento GPO' : 'GPO отопление',
      title: lang === 'it' ? 'Soluzione moderna per riscaldamento' : 'Современное решение для отопления'
    },
    {
      src: '/images/products/usage-gallery/1_Italian.jpeg',
      alt: lang === 'it' ? 'Termoventilatore GPO - infografica' : 'Обогреватель GPO - инфографика',
      title: lang === 'it' ? 'Caratteristiche tecniche' : 'Технические характеристики'
    },
    {
      src: '/images/products/usage-gallery/2_Italian.jpeg',
      alt: lang === 'it' ? 'Scaldasalviette GPO' : 'Полотенцесушитель GPO',
      title: lang === 'it' ? 'Scaldasalviette per bagno' : 'Полотенцесушитель для ванной'
    },
    {
      src: '/images/products/usage-gallery/3_Italian.jpeg',
      alt: lang === 'it' ? 'Vantaggi GPO' : 'Преимущества GPO',
      title: lang === 'it' ? 'Vantaggi dei prodotti GPO' : 'Преимущества продукции GPO'
    },
    {
      src: '/images/products/usage-gallery/4_Italian.jpeg',
      alt: lang === 'it' ? 'Controllo intelligente GPO' : 'Умное управление GPO',
      title: lang === 'it' ? 'Controllo WiFi dei termoventilatori' : 'WiFi управление обогревателями'
    },
    {
      src: '/images/products/usage-gallery/5_Italian.jpeg',
      alt: lang === 'it' ? 'Installazione termoventilatori GPO' : 'Установка обогревателей GPO',
      title: lang === 'it' ? 'Installazione semplice' : 'Простая установка'
    }
  ];

  const handleImageClick = (image, index) => {
    // Create a temporary product object for the gallery viewer
    const tempProduct = {
      name: { it: image.title, ru: image.title },
      model: lang === 'it' ? 'Galleria d\'uso' : 'Галерея использования',
      images: galleryImages.map(img => img.src),
      description: { it: image.alt, ru: image.alt },
      power: '',
      area: '',
      size: '',
      materials: { it: '', ru: '' },
      installation: { it: '', ru: '' },
      price: ''
    };

    onImageClick(tempProduct, index);
  };

  return (
    <section id="gallery" className="usage-gallery">
      <div className="container">
        <h2 className="section-title">
          {lang === 'it' ? 'Galleria d\'uso' : 'Галерея использования'}
        </h2>
        <p className="section-subtitle">
          {lang === 'it'
            ? 'Foto reali di termoventilatori GPO negli ambienti e infografica sui prodotti'
            : 'Реальные фотографии обогревателей GPO в интерьерах и инфографика о продуктах'
          }
        </p>

        <div className="gallery-grid">
          {galleryImages.map((image, index) => (
            <div
              key={index}
              className="gallery-item"
              onClick={() => handleImageClick(image, index)}
            >
              <div className="gallery-item-inner">
                <img
                  src={image.src}
                  alt={image.alt}
                  loading="lazy"
                  className="gallery-item-image"
                />
                <div className="gallery-item-overlay">
                  <div className="gallery-item-content">
                    <span className="gallery-item-icon">🔍</span>
                    <span className="gallery-item-title">{image.title}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="gallery-footer">
          <p className="gallery-note">
            {lang === 'it'
              ? '✨ Clicca su qualsiasi immagine per visualizzarla a dimensione intera'
              : '✨ Нажмите на любое изображение для просмотра в полном размере'
            }
          </p>
        </div>
      </div>
    </section>
  );
}

export default UsageGallery;
